import { faHome, faArchive, faFlask, faCrown, faSeedling } from "@fortawesome/free-solid-svg-icons"

export const menuData = [
	{ cTitle: "首页", eTitle: "HOME", icon: faHome, to: "/" },
	{ cTitle: "归档", eTitle: "ARCHIVE", icon: faArchive, to: "/" },
	{ cTitle: "实验室", eTitle: "LABORATORY", icon: faFlask, to: "/" },
	{ cTitle: "关于我", eTitle: "ABOUT ME", icon: faCrown, to: "/aboutme" },
	{ cTitle: "友人帐", eTitle: "FRIEND LINK", icon: faSeedling, to: "/" },
]

export const baseInfoData = [
	{ label: "昵称", value: "stempest" },
	{ label: "生日", value: "0925" },
	{ label: "星座", value: "天枰座" },
	{ label: "专业", value: "前端" },
	{ label: "故乡", value: "湖北随州" },
	{ label: "所在地", value: "广东深圳" },
	{ label: "爱好", value: "游戏/动漫/音乐/编码" },
	{ label: "颜色", value: "紫色" },
	{ label: "数字", value: "2" },
	{ label: "人格", value: "守卫者" },
	{ label: "偶像", value: "泽野弘之/潘玮柏/胡歌/Aimer/Reol" },
]

export const socialData = [
	{ label: "QQ", color: "#14baf8", icon: "icon-qq", action: () => {} },
	{ label: "微信", color: "#10d11e", icon: "icon-wechat", action: () => {} },
	{ label: "微博", color: "#e6162c", icon: "icon-weibo", action: () => {} },
	{ label: "邮箱", color: "#c90e1d", icon: "icon-email", action: () => {} },
	{ label: "网易云", color: "#e70012", icon: "icon-netease", action: () => {} },
	{ label: "bilibili", color: "#f08198", icon: "icon-bilibili", action: () => {} },
	{ label: "Steam", color: "#1375a8", icon: "icon-steam", action: () => {} },
	{ label: "Github", color: "#832790", icon: "icon-github", action: () => {} },
]
